"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComponentRendererWithContext = void 0;

var _react = _interopRequireDefault(require("react"));

var _context = require("../../context");

var _ComponentRendererWithQuery = require("../ComponentRendererWithQuery");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ComponentRendererWithContext = function ComponentRendererWithContext(_ref) {
  var className = _ref.className,
      variables = _ref.variables,
      componentMap = _ref.componentMap,
      context = _ref.context,
      queryMap = _ref.queryMap,
      type = _ref.type;
  return /*#__PURE__*/_react.default.createElement(_context.ContentfulProvider, {
    componentMap: componentMap,
    queryMap: queryMap
  }, /*#__PURE__*/_react.default.createElement(_ComponentRendererWithQuery.ComponentRendererWithQuery, {
    className: className,
    context: context,
    type: type,
    variables: variables
  }));
};

exports.ComponentRendererWithContext = ComponentRendererWithContext;